export const COMMUNITY_GUIDELINES_META = {
  title: "Community Guidelines",
  eyebrow: "Community desk",
  updatedAt: "August 22, 2026",
  readMinutes: 5,
  summary:
    "How people should behave on BetBond P2P: respect, privacy, fair play, and reporting.",
  intro:
    "How we expect people to behave on BetBond’s peer-to-peer community. By participating, you agree to these guidelines.",
  platformNote:
    "BetBond works when participants treat each other fairly on P2P offers, invites, and chat. These rules sit alongside our Terms of Service and apply to messages, profiles, offers, and any community-facing activity.",
};

export const COMMUNITY_PROMISES = [
  {
    id: "respect",
    label: "Be civil",
    detail: "Disagree without abuse—in chat and on offers.",
  },
  {
    id: "fair",
    label: "Play fair",
    detail: "No collusion, fake joins, or abusing P2P escrow.",
  },
  {
    id: "report",
    label: "Speak up",
    detail: "Use in-app reporting when something crosses the line.",
  },
];

export const COMMUNITY_SECTIONS = [
  {
    id: "respect",
    title: "Respect",
    index: "01",
    blocks: [
      {
        prose:
          "Be civil in chat, invites, and P2P offer descriptions. No harassment, hate speech, slurs, or targeting people for who they are. Disagree without abuse. BetBond is for constructive peer-to-peer sports matching.",
      },
    ],
  },
  {
    id: "prohibited",
    title: "What not to post",
    index: "02",
    blocks: [
      { prose: "Do not post or share:" },
      {
        bullets: [
          "Illegal content or instructions to break the law",
          "Threats, violence, or coordination of harm",
          "Sexual or exploitative content involving minors",
          "Non-consensual intimate imagery or doxxing",
          "Spam, malware, or deceptive links in chat or offers",
          "Others' private information without permission",
        ],
      },
    ],
  },
  {
    id: "fair",
    title: "Fair P2P play",
    index: "03",
    blocks: [
      {
        prose:
          "Be honest when creating, joining, or inviting others to P2P offers. Do not collude, fake acceptances, abuse escrow or refunds, use inside information unfairly, or exploit bugs. Accept settlements that follow the offer rules and independent fixture verification where we use it.",
      },
    ],
  },
  {
    id: "privacy",
    title: "Privacy",
    index: "04",
    blocks: [
      {
        prose:
          "Do not pressure others to share passwords, payment details, or sensitive personal data. Respect boundaries and report suspicious account behavior through the app.",
      },
    ],
  },
  {
    id: "spam",
    title: "Promotion & spam",
    index: "05",
    blocks: [
      {
        prose:
          "Keep chat and invites relevant to P2P sports matching. No repetitive junk, unsolicited bulk messages, or paid ads and affiliate links unless BetBond explicitly authorizes them.",
      },
    ],
  },
  {
    id: "enforcement",
    title: "Enforcement & reports",
    index: "06",
    blocks: [
      {
        prose:
          "We may remove content, limit P2P features, or suspend accounts that break these guidelines or our Terms. Use in-app reporting for concerns. Repeated or serious violations can lead to permanent removal.",
      },
    ],
  },
  {
    id: "changes",
    title: "Changes",
    index: "07",
    blocks: [
      {
        prose:
          "We may update these guidelines. If changes matter, we will give notice when reasonable, for example in the app. Continued use means you accept the updated guidelines.",
      },
    ],
  },
];
